export * from './region';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_qiniu-js@3.4.1@qiniu-js/esm/config/index.js
// module id = 577
// module chunks = 362